// extracted by mini-css-extract-plugin
module.exports = {"filter":"styles_filter__1GtB5","table":"styles_table__1e-6F","module":"styles_module__v8BpJ"};